var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentFile,{tag:"component",staticClass:"svg-inline"})
}
var staticRenderFns = []

export { render, staticRenderFns }